/**
 * Created by andrey on 18.05.2026
 */

const EditorCommandLogView = cc.Node.extend({
    ctor: function (commandLog) {
        this._super();

        this.commandLog = commandLog;
        this.entryViews = [];

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(cleverapps.styles.EditorCommandLogView);

        this.createContent();

        commandLog.entries.forEach(function (entry) {
            this.addEntry(entry);
        }, this);

        commandLog.on("addEntry", this.addEntry.bind(this), this);

        this.updatePlaceholder();
        this.updateVersion();
    },

    addEntry: function (entry) {
        const view = new EditorCommandLogEntryView(entry, this.entryViews.length, this.commandLog);
        this.entryViews.push(view);
        view.x = this.width / 2;
        this.content.addChild(view);
        this.updateContent();
        this.updatePlaceholder();
        this.updateVersion();
    },

    updateVersion: function () {
        const adminLocations = cleverapps.administrator && cleverapps.administrator.adminLocations;
        const location = adminLocations && adminLocations.activeLocation;
        const content = location && location.getContent();
        const version = (content && content.version) || "";

        this.versionText.setScale(1);
        this.versionText.setString(version);

        if (version) {
            cleverapps.UI.fitToBox(this.versionText, { width: this.width - cleverapps.styles.EditorCommandLogView.paddingX * 2 });
        }
    },

    updatePlaceholder: function () {
        this.placeholder.setVisible(this.entryViews.length === 0);
    },

    updateContent: function () {
        this.content.reshape();
        this.scroll.updateInnerContent();

        const last = this.entryViews[this.entryViews.length - 1];
        if (last) {
            this.scroll.scrollTo(last);
        }
    },

    createContent: function () {
        const styles = cleverapps.styles.EditorCommandLogView;

        const bg = cleverapps.UI.createScale9Sprite(bundles.git.frames.button, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setContentSize(this.getContentSize());
        bg.setAlignment(this.width / 2, this.height / 2);
        this.addChild(bg, -1);

        const placeholder = this.placeholder = cleverapps.UI.generateOnlyText("No actions yet", cleverapps.styles.FONTS.ADMIN_LOG_FONT);
        placeholder.setAlignment(this.width / 2, this.height / 2);
        this.addChild(placeholder);

        const version = this.versionText = cleverapps.UI.generateOnlyText("", cleverapps.styles.FONTS.ADMIN_LOG_FONT);
        version.setAnchorPoint(0.5, 0.5);
        version.setAlignment(this.width / 2, this.height - styles.paddingY);
        this.addChild(version);

        const content = this.content = new cleverapps.Layout([], {
            direction: cleverapps.UI.VERTICAL
        });

        const scrollWidth = this.width - styles.paddingX * 2;
        const scrollHeight = this.height - styles.paddingY * 2;

        const scroll = this.scroll = new cleverapps.UI.ScrollView(content, {
            direction: cleverapps.UI.ScrollView.DIR_VERTICAL,
            dock: true
        });
        scroll.setContentSize(scrollWidth, scrollHeight);
        this.addChild(scroll);
        scroll.setAlignment(styles.scroll);

        cleverapps.UI.onDrag(this, {
            followPointer: true,
            filter: (touch) => {
                const point = touch.getLocation();
                return cc.rectContainsPoint(bg.getGlobalBoundingBox(), point)
                    && !cc.rectContainsPoint(scroll.getGlobalBoundingBox(), point);
            }
        });
    }
});

cleverapps.styles.EditorCommandLogView = {
    width: 400,
    height: 250,
    paddingX: 5,
    paddingY: 15,

    scroll: {
        x: { align: "center" },
        y: { align: "center", dy: -10 }
    }
};
